import scan from "rfuncs/functions/scan"

import state from "../state/main"

export default (key, value) => scan((v, k) => (state[key][k] = v), value)
